import praxisTokens from './styles/tokens';
import { praxisShell } from './styles/shell';
import { praxisSidebar } from './styles/sidebar';
import { praxisMessages } from './styles/messages';
import { praxisComposer } from './styles/composer';
import { praxisEmptyState } from './styles/emptyState';
import { praxisActionCards } from './styles/actionCards';
import { praxisEmailDraft } from './styles/emailDraft';
import { praxisCardFields } from './styles/cardFields';
import { praxisSidePanel } from './styles/sidePanel';
import { praxisSettings } from './styles/settings';
import { praxisRunSections } from './styles/runSections';
import { praxisThinkingBlock } from './styles/thinkingBlock';

/**
 * Canonical composition of the praxis (assistant chat) stylesheet
 * (orig. WEB-5972, split per feature in WEB-7962/WEB-8005).
 *
 * Chat surfaces live inside a Shadow DOM (`ShadcnScope`) and only see the
 * stylesheets injected in that scope, so consumers render this sheet as a
 * `<style>` child. Current consumers: AIWorkspace (both render branches),
 * AgentPagesPage, LiveCoach, DashboardAiSuggestions, FloatingAIChat,
 * EmbedAIChat. The `.praxis` scoping keeps Salesboard and other shadcn
 * surfaces on their own tokens.
 *
 * The fragment order below IS the original sheet's source order and is part
 * of the CSS cascade — don't reorder, and add new fragments at the position
 * their rules should cascade.
 */
const praxisStyles =
	praxisTokens +
	praxisShell +
	praxisSidebar +
	praxisMessages +
	praxisComposer +
	praxisEmptyState +
	praxisActionCards +
	praxisEmailDraft +
	praxisCardFields +
	praxisSidePanel +
	praxisSettings +
	praxisRunSections +
	praxisThinkingBlock;

export default praxisStyles;
